// Pantalla `command="login-oauth2-device-verify-user-code"`: el usuario
// introduce el código que le muestra el dispositivo (RFC 8628; p. ej.
// `facturadirecta login --device`). Se llega aquí abriendo /device sin
// user_code en la URL, o con un código no válido o caducado (el error llega
// en data.message). Submit normal al endpoint de verificación de Keycloak.

import type { FormEvent } from "react";
import type { KcData } from "../kcData";
import { Input } from "../components/Input";
import { StandardPage } from "../components/StandardPage";
import { msg } from "../i18n";

interface DeviceVerification {
  action: string;
}

function getDeviceVerification(data: KcData): DeviceVerification | undefined {
  return (
    (data.form?.deviceVerification as DeviceVerification | undefined) ??
    (data as unknown as { deviceVerification?: DeviceVerification })
      .deviceVerification
  );
}

export interface DeviceVerifyUserCodePageProps {
  data: KcData;
  running: boolean;
  onSubmit: (e: FormEvent<HTMLFormElement>) => void;
}

export function DeviceVerifyUserCodePage(props: DeviceVerifyUserCodePageProps) {
  const { data, running, onSubmit } = props;
  const verification = getDeviceVerification(data);

  return (
    <StandardPage page="login-oauth2-device-verify-user-code" data={data}>
      <div>
        <form
          id="kc-user-verify-device-user-code-form"
          action={verification?.action}
          method="post"
          onSubmit={onSubmit}
        >
          <p className="instruction">{msg("verifyOAuth2DeviceUserCode")}</p>
          <Input
            type="text"
            id="device-user-code"
            name="device_user_code"
            placeholder="XXXX-XXXX"
            autoComplete="off"
            autoFocus
            messagesPerField={data.messagesPerField}
          />
          <div className="form-group">
            <button
              type="submit"
              className="btn btn-lg btn-block btn-primary"
              disabled={running}
            >
              {msg("doContinue")}
            </button>
          </div>
        </form>
      </div>
    </StandardPage>
  );
}
